module.exports = __webpack_public_path__ + "img/sencillito.c6dd20e.png";